import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import ClassIcon from "@material-ui/icons/Class";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import CommentIcon from "@material-ui/icons/Comment";
import ListIcon from "@material-ui/icons/List";
import ReactDOM from "react-dom";
import DocumentItem from "./ItemDocument";
import ItemKnowledgeItem from "./ItemKnowledgeItem";
import DiscussionItem from "./ItemDiscussions";
import EntryItem from "./ItemEntries";
import RequiredReadingItem from "./ItemRequiredReading";
import SearchItem from "./SearchItem";
import ItemSearches from "./ItemSearches";
import ListItem from "./ItemList";
import { withTranslation } from "react-i18next";
import { withTheme, withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import { Trans } from "react-i18next";
import Popover from "@material-ui/core/Popover";
import Menu from "@material-ui/core/Menu";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import RequiredReadingDialog from "./../required-reading/RequiredReadingDialog";
import axios, { contentClient, discussionClient } from "../../AxiosClient";
import KpsTextField from "../KpsTextField";
/**
 * Generic wrapper for a User List, can hold any other item within it
 */

const styles = (theme) => ({
  paper: {
    overflow: "visible",
  },
  arrow: {
    position: "absolute",
    top: -18,
    left: 20,
    borderLeft: "20px solid transparent",
    borderRight: "20px solid transparent",
    borderBottom: "20px solid white",
    width: 0,
    height: 0,
  },
  content: {
    padding: 5,
  },
  popover: {
    marginTop: -30,
    marginLeft: 30,
  },
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
      marginRight: "8px",
    },
    verticalAlign: "middle",
  },
});
export class AnyItem extends Component {
  itemRef = React.createRef();

  state = {
    itemData: {},
    instance: (
      new Date().getTime() + Math.floor(Math.random() * 1000)
    ).toString(),
    commentPopoverOpen: false,
    menuAnchorEl: null,
    comment: this.props.data.comment || "",
    instance: Date.now().toString(),
    requiredReadingOpen: false,
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data.id !== this.props.data.id) {
      this.getData();
    }
  }

  getData = () => {
    let url, params;
    let client = axios;
    switch (this.props.data.type) {
      case "knowledgeItem":
        this.Item = ItemKnowledgeItem;
        this.Icon = ClassIcon;
        url = `/knowledgeitem/${this.props.data.id}`;
        client = contentClient;
        break;
      case "document":
        this.Item = DocumentItem;
        this.Icon = ChromeReaderModeIcon;
        url = `/document/${this.props.data.id}`;
        params = {
          displayDraft: false,
        };
        break;
      case "discussion":
        this.Item = DiscussionItem;
        this.Icon = QuestionAnswerIcon;
        url = `/discussion/${this.props.data.id}`;
        client = discussionClient;
        break;
      case "entry":
        this.Item = EntryItem;
        this.Icon = CommentIcon;
        url = `/entry/${this.props.data.id}`;
        client = discussionClient;
        break;
      case "requiredReading":
        this.Item = RequiredReadingItem;
        this.Icon = PlaylistAddCheckIcon;
        url = `/requiredreading/${this.props.data.id}`;
        break;
      case "searchGroup":
        this.Item = ItemSearches;
        this.Icon = SearchIcon;
        // this.setState({ itemData: this.props.data.itemData });
        url = `/searchhistory/searchgroup/${this.props.data.id}`;
        break;
      case "search":
        this.Item = SearchItem;
        this.setState({ itemData: this.props.data.itemData });
        break;
      default:
        break;
    }

    if (this.props.data.items) {
      this.Item = ListItem;
      this.Icon = ListIcon;
      url = `/userlist/${params.listID}/items`;
      params = {
        listID: this.props.data.id,
      };
    }

    if (url) {
      if (!params) {
        params = {};
      }
      client
        .get(url, {
          params,
        })
        .then((res) => {
          this.setState({ itemData: res.data });
        });
    }
  };

  render() {
    const { classes, theme, t } = this.props;
    let Item = this.Item;
    let Icon = this.Icon;
    const draggableProps = this.props.provided
      ? this.props.provided.draggableProps
      : {};

    const child = (
      <div>
        <div style={{ display: "flex" }}>
          {(!this.props.snapshot || (this.props.snapshot &&
            !this.props.snapshot.isDragging)) && (this.props.data.canEdit || this.props.data.canEdit === true) && (
              <div>
                <div style={{ display: "flex", height: "100%" }}>
                  <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                    <IconButton
                      color="inherit"
                      aria-owns={
                        this.state.menuAnchorEl ? "layout-menu" : undefined
                      }
                      onClick={this.toggleMenu}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="layout-menu"
                      anchorEl={this.state.menuAnchorEl}
                      open={Boolean(this.state.menuAnchorEl)}
                      onClose={this.closeMenu}
                    >
                      <MenuItem onClick={this.onItemRemove}>
                        <Trans i18nKey="portlet_remove_item_from_list" />
                      </MenuItem>
                      <MenuItem onClick={this.commentOnItem}>
                        <Trans i18nKey="portlet_comment_on_item" />
                      </MenuItem>
                      {this.props.data.type === "document" && (
                        <MenuItem onClick={this.makeRequiredReading}>
                          <Trans i18nKey="make_required_reading" />
                        </MenuItem>
                      )}
                    </Menu>
                  </div>
                  {Object.keys(this.state.itemData).length > 0 && this.state.requiredReadingOpen && (
                    <RequiredReadingDialog
                      open={this.state.requiredReadingOpen}
                      handleClose={this.handleRequiredReadingClose}
                      handleSubmit={this.handleRequiredReadingSubmit}
                      initialDocuments={[this.state.itemData]}
                    />
                  )}
                  <Popover
                    open={this.state.commentPopoverOpen}
                    anchorEl={this.itemRef.current}
                    onClose={this.handlePopoverClose}
                    classes={{ paper: classes.paper }}
                    className={classes.popover}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <div className={classes.arrow} />
                    <div className={classes.content}>
                      <DialogTitle>
                        <Trans i18nKey="portlet_comment_on_item_dialog_header" />
                      </DialogTitle>
                      <DialogContent>
                        <Typography>
                          <Trans i18nKey="portlet_comment_on_item_dialog_body" />
                        </Typography>
                        <KpsTextField
                          id="outlined-comment"
                          label={this.props.t("portlet_comment_on_item_label")}
                          value={this.state.comment ? this.state.comment : ""}
                          onChange={this.handleCommentChange}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.handlePopoverClose}>
                          <Trans i18nKey="global_cancel" />
                        </Button>
                        <Button onClick={this.saveItemComment}>
                          <Trans i18nKey="global_save" />
                        </Button>
                      </DialogActions>
                    </div>
                  </Popover>
                </div>
              </div>
            )}
          <div style={{ flexGrow: 1 }}>

            {Object.keys(this.state.itemData).length > 0 &&
              Item && (
                <div {...draggableProps}>
                  {this.state.comment && (
                    <div style={{ display: "flex", marginTop: theme.spacing(1.5) }}>
                      <span
                        style={{
                          fontSize: "1.4em",
                          marginRight: "8px",
                          color: theme.palette.secondary.light,
                        }}
                        class="mdi mdi-lightbulb-on-outline"
                      />
                      <span style={{ color: theme.palette.text.secondary, marginTop: theme.spacing(0.6) }}>
                        {this.state.comment}
                      </span>
                    </div>
                  )}
                  <Item
                    discussionPortlet={this.props.data.type === "discussion"}
                    provided={this.props.provided}
                    snapshot={this.props.snapshot}
                    data={this.state.itemData}
                    secondaryInfo={null}
                    preText={
                      Icon && (
                        <div
                          ref={this.itemRef}
                          style={{
                            color: this.props.theme.palette.text.secondary,
                            display: "block",
                          }}
                        >
                          <span className={classes.iconSpan}>
                            <Icon />
                          </span>
                        </div>
                      )
                    }
                  />
                </div>
              )}
          </div>
        </div>
      </div>
    );
    if (this.props.snapshot && this.props.snapshot.isDragging) {
      return ReactDOM.createPortal(child, document.body);
    }
    return child;
  }

  saveItemComment = () => {
    let params = JSON.parse(this.props.portlet.parameters)
    axios
      .patch(`/userlist/${JSON.parse(this.props.portlet.parameters).listID}`, {
        id: JSON.parse(this.props.portlet.parameters).listID,
        itemId: this.state.itemData.documentID
          ? this.state.itemData.documentID
          : this.state.itemData.discussionId
            ? this.state.itemData.discussionId
            : this.state.itemData.itemId,
        comment: this.state.comment,
      })
      .then((res) => {
        this.handlePopoverClose();
      });
  };

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  };

  handleRequiredReadingClose = () => {
    this.setState({ requiredReadingOpen: false });
  };

  handleRequiredReadingSubmit = () => {
    this.setState({ requiredReadingOpen: false });
  };

  makeRequiredReading = () => {
    this.setState({ requiredReadingOpen: true });
  };

  toggleMenu = (e) => {
    e.stopPropagation();
    this.setState({ menuAnchorEl: e.currentTarget });
  };

  closeMenu = () => {
    this.setState({ menuAnchorEl: null });
  };

  onItemRemove = () => {
    this.props.onItemRemove(this.props.itemIndex);
  };

  commentOnItem = () => {
    this.setState({ commentPopoverOpen: true, menuAnchorEl: null });
  };

  handlePopoverClose = () => {
    this.setState({ commentPopoverOpen: false });
  };
}

const mapStateToProps = (state) => ({
  settings: state.setting.documentSettings,
});

export default connect(
  mapStateToProps,
  null
)(withRouter(withTranslation()(withTheme(withStyles(styles)(AnyItem)))));
